import React from 'react';

import { useIntl } from 'ha/i18n';
import {
  FacilitiesFilterCount,
  FacilitiesValue,
  FacilitiesFilterValue,
} from 'ha/types/SearchFilters';

import { CommonCheckboxFilter } from './CommonCheckboxFilter';
import { CommonCheckboxTitleWithCount } from './CommonCheckboxTitleWithCount';

interface Props {
  value: FacilitiesFilterValue;
  onChange: (value: FacilitiesFilterValue) => void;
  count?: FacilitiesFilterCount;
}

const FacilitiesFilter: React.FC<Props> = ({ value, onChange, count }) => {
  const { T } = useIntl();

  return (
    <CommonCheckboxFilter
      value={value}
      onChange={onChange}
      options={[
        {
          value: FacilitiesValue.PRIVATE_BATHROOM,
          title: (
            <CommonCheckboxTitleWithCount
              title={T('private bathroom')}
              count={count?.privateBathroom}
            />
          ),
          testLocator: 'Filter Private Bathroom',
        },
        {
          value: FacilitiesValue.BALCONY_TERRACE,
          title: (
            <CommonCheckboxTitleWithCount
              title={T('Balcony/Terrace')}
              count={count?.balconyTerrance}
            />
          ),
          testLocator: 'Filter Balcony Terrance',
        },
        {
          value: FacilitiesValue.GARDEN,
          title: (
            <CommonCheckboxTitleWithCount
              title={T('Garden')}
              count={count?.garden}
            />
          ),
          testLocator: 'Filter Garden',
        },
        {
          value: FacilitiesValue.KITCHEN,
          title: (
            <CommonCheckboxTitleWithCount
              title={T('Kitchen')}
              count={count?.kitchen}
            />
          ),
          testLocator: 'Filter Kitchen',
        },
        {
          value: FacilitiesValue.PET_FRIENDLY,
          title: (
            <CommonCheckboxTitleWithCount
              title={T('listing.facilities.animal_allowed.yes')}
              count={count?.petsFriendly}
            />
          ),
          testLocator: 'Filter Pet Friendly',
        },
        {
          value: FacilitiesValue.PARKING,
          title: (
            <CommonCheckboxTitleWithCount
              title={T('Parking')}
              count={count?.parking}
            />
          ),
          testLocator: 'Filter Parking',
        },
        {
          value: FacilitiesValue.WHEELCHAIR_ACCESSIBLE,
          title: (
            <CommonCheckboxTitleWithCount
              title={T('Wheelchair accessible')}
              count={count?.wheelchairAccessible}
            />
          ),
          testLocator: 'Filter Wheelchair Accessible',
        },
        {
          value: FacilitiesValue.BASEMENT,
          title: (
            <CommonCheckboxTitleWithCount
              title={T('Basement')}
              count={count?.basement}
            />
          ),
          testLocator: 'Filter Basement',
        },
      ]}
    />
  );
};

export { FacilitiesFilter };
